export const environment = {
  production: false,
  baseHref: '/',
  redirectUri: 'https://newptm.amgreetings.com/',
  postLogoutRedirectUri: 'https://newptm.amgreetings.com/',
  webApi: 'https://newptm-api.prod.ag2goservices.amgreetings.com',
  // ESS is served at the root of this hostname (the former ESS dashboard DNS); '' keeps ESS under /ess
  essHost: 'ess.amgreetings.com',
  // Google Address Validation / Geocoding (ESS Permanent Residence, Mailing Address)
  googleApiKey: 'AIzaSyDe_6K2nTUe3Ra-2QHu8tGo9oHk8YZfAD0',
  tablePaginationSizes: [10, 25, 100],
  pageableAllItems: 99999,
  noLoadingSpinnerHeader: 'loading-spinner-disabled',
  httpRequestChunkSize: 100
};
